module.exports = __webpack_public_path__ + "static/media/template_image.16def2b1.png";